import React from 'react'
import ReactDOM from 'react-dom'
import { renderRoutes } from 'react-router-config'
import { BrowserRouter } from 'react-router-dom'
import routes from './app/routes'

const App = <BrowserRouter>{renderRoutes(routes)}</BrowserRouter>

ReactDOM[module.hot ? 'render' : 'hydrate'](App, document.getElementById('root'))
